<template>
  <div class="product-introduction">
    <headline />
    <div class="title">
      <div class="title-left">
        <img class="timely" src="./img/u3347.png" alt />
        <img class="inverse-time" src="./img/u3349.png" alt />
      </div>
      <div class="written">
        <span
          >积极贯彻落实《中国教育现代化2035》，《关于全面加强和改进新时代学校体育工作的意见》，《深化新时代教育评价改革总体方案》，《关于强化学校体育促进学生身心健康全面发展的意见》等文件精神。北京厚德宥马网络科技有限公司通过现代教育技术和互联网、物联网等现代化技术的融合运用，结合多年来在体育教育领域所积累的丰富经验，正式推出“学校体育管理信息化平台”
          产品，致力于解决当前智慧体育教学管理建设过程中都普遍存在着的：重复投资、资源利用率低；标准不统一、集成整合难；系统众多、学生体验差以及信息资源分散、检索不便等问题。</span
        >
        <!-- <img src="./img/written-words.png" alt /> -->
      </div>
      <!-- <div class="title-right">
        <p>积极贯彻落实《国家中长期教育改革和发展规划纲要（2010—2020年）》，《国务院办公厅关于强化学校体育促进学生身心健康全面发展的意见》（国办发〔2016〕27号），《高等学校体育工作基本标准》（教体艺〔2014〕4号），《教育信息化“十三五”规划》（教技〔2016〕2号），《教育信息化2.0行动计划》（教技〔2018〕6号），《教育部关于深化本科教育教学改革全面提高人才培养质量的意见》（教高〔2019〕6号）等文件精神。北京厚德宥马网络科技有限公司通过现代教育技术和互联网、物联网等现代化技术的融合运用，结合多年来在体育教育领域所积累的丰富经验，正式推出“学校体育管理信息化平台” 产品，致力于解决当前智慧体育教学管理建设过程中都普遍存在着的：重复投资、资源利用率低；标准不统一、集成整合难；系统众多、学生体验差以及信息资源分散、检索不便等问题。</p>
      </div>-->
    </div>
    <div class="switch">
      <span>
        <a @click="Top('#totalSolution')">解决方案</a>
      </span>
      <span>
        <a @click="Top('#goodness')">我们的优势</a>
      </span>
      <span>
        <a @click="Top('#caseCooperation')">合作案例</a>
      </span>
    </div>
    <div id="totalSolution" class="solution">
      <h1>“互联网+体育教育” 解决方案</h1>
      <div>
        <img src="./img/u230821.png" alt />
        <div class="bnack"></div>
      </div>
      <div class="solution-details">
        <p>
          宥马运动-学校体育管理信息化平台，是经业内多位权威专家的精心指导和众多奋斗在教学一线的体育教师们倾囊传授下，通过我司不断的深入研究和实践，最终研发成型，其主要功能包含教师端学校体育日常管理工作、竞赛管理、场馆管理和学生锻炼管理、体质健康管理等。利用互联网、物联网等信息化技术，使体育工作在保留原有的教学特点时，同时具有智能化、数字化、数据可视化的教学过程和成果展示，有效提升一线教师和管理者工作效率；同时，我司利用平台各功能营造各种奖励机制，引导学生正确对待体育课程与课外锻炼，促进学生体质健康良性发展。
        </p>
      </div>
      <!--  <div class="solution-carousel">
        <Carousel
          v-model="handset"
          loop
          autoplay
          arrow="never"
          dots="none"
          :autoplay-speed="5000"
        >
          <CarouselItem>
            <img class="demo-carousel" src="./img/u3301.png" alt />
          </CarouselItem>
          <CarouselItem>
            <img class="demo-carousel" src="./img/u3306.png" alt />
          </CarouselItem>
          <CarouselItem>
            <img class="demo-carousel" src="./img/u3311.png" alt />
          </CarouselItem>
          <CarouselItem>
            <img class="demo-carousel" src="./img/u3315.png" alt />
          </CarouselItem>
          <CarouselItem>
            <img class="demo-carousel" src="./img/u3319.png" alt />
          </CarouselItem>
        </Carousel>
      </div>-->
    </div>
    <div class="dividing-line"></div>
    <div id="goodness" class="advantage">
      <h1>我们的优势</h1>
      <p class="advantage-title">1、多系统集成融合</p>
      <p>
        <img class="icon" src="./img/u3271.png" />
        <span
          >&nbsp;开放、融合，无缝集成各子系统，打造一体化学校体育管理教务大平台。</span
        >
      </p>
      <p>
        <img src="./img/u3271.png" />
        <span class="thickening">&nbsp;平台架构具备开放性</span>
      </p>
      <p>
        <img src="./img/u3271.png" />
        <span class="thickening">&nbsp;门户支撑能力</span>
      </p>
      <p>
        <img class="icon" src="./img/u3271.png" />
        <span
          >&nbsp;打造统一接入的一体化学校体育教务管理大平台，实现数据的整合、公共支撑能力的整合以及业务层的整合，最终给用户提供一个统一办公入口的平台，实现一个平台内查看及处理多个系统推送的待办事宜，邮件、会议。</span
        >
      </p>
      <p class="advantage-title">2、办公移动智能化</p>
      <p>
        <img src="./img/u3271.png" />
        <span class="thickening">&nbsp;全面的移动办公能力</span>
      </p>
      <p>
        <img class="icon" src="./img/u3271.png" />
        <span
          >&nbsp;移动版在传统App的基础上，扩展出微信、微博等接入渠道，供用户任意选择，进而快速延伸移动办公的覆盖面。</span
        >
      </p>
      <p>
        <img src="./img/u3271.png" />
        <span class="thickening">&nbsp;多样的渠道支持</span>
      </p>
      <p>
        <img class="icon" src="./img/u3271.png" />
        <span
          >&nbsp;宥马运动-移动版，真正实现了体育教学管理办公功能的全覆盖，让用户能够随时随地，高效快捷地完成事务的处理。</span
        >
      </p>
      <p class="advantage-title">3、统一的消息中心</p>
      <p>
        <img class="icon" src="./img/u3271.png" />
        <span
          >&nbsp;学校体育管理信息化平台移动版建立了统一的消息中心，将各模块中的新消息都汇总在通知消息中心，并进行分类展示，实现了事找人，及时提醒高效处理。</span
        >
      </p>
      <p class="advantage-title">4、为学校体育决策提供科学依据</p>
      <p>
        <img class="icon" src="./img/u3271.png" />
        <span
          >&nbsp;好的决策是成功的一半，学校治理的关键在于决策。然而，当代学校管理事务日趋复杂化，缺乏信息支持的决策往往顾此失彼。大数据应用于学校治理有利于揭示事务的内在关联性，利用数据融合、数学模型、仿真技术等大数据技术可以提高决策层对信息的占有与分析能力，为科学决策提供数据支持，从而大大提高学校体育决策的科学性。</span
        >
      </p>
      <p class="advantage-title">5、为体育教学管理精准化提供数据支撑</p>
      <p>
        <img class="icon" src="./img/u3271.png" />
        <span
          >&nbsp;大数据应用于教学管理，有效地解决了繁杂的管理信息、分散的管理资源与精准的管理需求、高效的管理效率之间的巨大矛盾，使得传统教学条件下长期存在的——“信息不能有效交换与共享、难以统一、部门协作存在瓶颈”的局面得到极大改观，推动体育教学管理由粗放向精细化转变。</span
        >
      </p>
      <p class="advantage-title">6、为学校体育管理模式转型创造条件</p>
      <p>
        <img class="icon" src="./img/u3271.png" />
        <span
          >&nbsp;在习近平新时代，各行各业海量数据不断涌现，使得学校体育的治理模式，包括体制、结构、职能、流程和方式等发生了革命性的变化。通过与现代教育技术和互联网、物联网等现代化技术手段紧密结合的学校体育管理信息化平台对加强体育课程建设、深化体育教学改革、开展学校体育活动、完善学生体育评价、促进学生体质健康、提升学校体育管理水平提供重要支持，为学校体育管理模式转型创造有利条件。</span
        >
      </p>
      <p class="advantage-title">
        7、为提高教学服务能力，满足学生个性化、差异化、多样化、优质化教育需求提供便利。
      </p>
    </div>
    <div id="caseCooperation" class="cooperation-case">
      <h1>合作案例</h1>
      <div class="cooperation-case-cil">
        <div>
          <img src="./img/ZJTIE.png" alt />
          <div>
            <img src="./img/ZJTIE-logo.png" alt />
            <span>浙江经济职业技术学院</span>
          </div>
        </div>
        <div>
          <img src="./img/technology.png" alt />
          <div>
            <img src="./img/technology-logo.png" alt />
            <span>营口理工学院</span>
          </div>
        </div>
        <div>
          <img src="./img/academy.png" alt />
          <div>
            <img src="./img/academy-logo.png" alt />
            <span>浙江警官职业学院</span>
          </div>
        </div>
      </div>
      <div class="cooperation-case-cil">
        <div>
          <img src="./img/college.png" alt />
          <div>
            <img src="./img/college-logo.png" alt />
            <span>滁州职业技术学院</span>
          </div>
        </div>
        <div>
          <img src="./img/health.png" alt />
          <div>
            <img src="./img/health-logo.png" alt />
            <span>红河卫生职业学院</span>
          </div>
        </div>
        <div>
          <img src="./img/commerce.png" alt />
          <div>
            <img src="./img/commerce-logo.png" alt />
            <span>浙江商业职业技术学院</span>
          </div>
        </div>
      </div>
    </div>
    <div class="dividing-line"></div>
    <div class="service">
      <h1>服务得到用户一致好评</h1>
      <div>
        <img src="./img/WeChat0b6aed909c84497ab4c2c853137026e4.png" alt />
        <img src="./img/WeChat21feae3850314d27cda02473ec748f9a.png" alt />
        <img src="./img/WeChat26284575ae9854426ebcf1401f6a4b50.png" alt />
        <img src="./img/WeChat69c9771818a4986471497c4750f99b75.png" alt />
        <img src="./img/WeChat8303b184737b26729602b8b79feb6110.png" alt />
        <img src="./img/WeChata343dd53120348645eb6d712ce0309ac.png" alt />
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import headline from "@/components/headline/headline";
import foot from "@/components/foot/foot";

export default {
  name: "product-introduction",
  data() {
    return {
      handset: 0
    };
  },
  methods: {
    Top(num) {
      document.querySelector(num).scrollIntoView(true);
    }
  },
  components: {
    headline,
    foot
  }
};
</script>

<style lang="less" scoped>
.product-introduction {
  .title {
    background-image: url(./img/u3189.jpg);
    background-repeat: round;
    width: 100%;
    height: 5.32rem;
    position: relative;
    .title-left {
      position: relative;
      width: 3.7rem;
      height: 3.7rem;
      padding: 1.18rem 0 0 0.93rem;
      img {
        position: absolute;
        width: 3.73rem;
        height: 3.73rem;
      }
      .timely {
        animation: gyrate 10s infinite linear;
        -moz-animation: gyrate 10s infinite linear; /* Firefox */
        -webkit-animation: gyrate 10s infinite linear; /* Safari 和 Chrome */
        -o-animation: gyrate 10s infinite linear; /* Opera */
      }
      .inverse-time {
        animation: revolve 10s infinite linear;
        -moz-animation: revolve 10s infinite linear; /* Firefox */
        -webkit-animation: revolve 10s infinite linear; /* Safari 和 Chrome */
        -o-animation: revolve 10s infinite linear; /* Opera */
      }
    }
    .written {
      position: absolute;
      top: 35%;
      right: 6%;
      span {
        display: block;
        max-width: 10rem;
        font-size: 0.19rem;
        font-weight: 600;
        text-indent: 0.4rem;
        color: white;
        line-height: 0.36rem;
        text-align: justify;
        word-break: break-all;
        text-justify: distribute;
      }
    }
    .title-right {
      display: flex;
      align-items: center;
      p {
        width: 7.3rem;
        color: white;
        font-weight: 400;
        font-size: 0.22rem;
        text-indent: 0.4rem;
      }
    }
  }
  .switch {
    height: 1rem;
    background: rgba(255, 255, 255, 1);
    padding-left: 2.55rem;
    span {
      font-size: 0.2rem;
      font-weight: 600;
      line-height: 1rem;
      cursor: pointer;
      margin-right: 0.8rem;
      a {
        color: rgba(34, 34, 34, 1);
      }
    }
    span:first-child {
      a {
        color: rgba(1, 102, 255, 1);
      }
    }
  }
  .solution {
    position: relative;
    margin-bottom: 0.5rem;
    & > div {
      position: relative;
      & > img {
        width: 10.77rem;
        margin-left: 10%;
      }
    }
    .bnack {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 4.64rem;
      background-color: rgba(222, 222, 224, 1);
      z-index: -1;
    }
    h1 {
      font-size: 0.5rem;
      color: rgba(34, 34, 34, 1);
      font-weight: 600;
      padding-left: 1.6rem;
      padding-top: 0.55rem;
      background-color: rgba(222, 222, 224, 1);
    }
    .solution-details {
      bottom: 0;
      padding: 0 1.6rem;
      p {
        font-size: 0.24rem;
        font-weight: 400;
        color: black;
        text-indent: 0.4rem;
        line-height: 0.4rem;
        text-align: justify;
      }
    }
    .solution-carousel {
      position: absolute;
      right: 20%;
      bottom: 30%;
      width: 2.4rem;
      height: 4.48rem;
      background-image: url(./img/handset.png);
      background-repeat: round;
      .ivu-carousel {
        width: 2rem;
        height: 4rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        img {
          width: 2rem;
          height: 4rem;
        }
      }
    }
  }
  .dividing-line {
    height: 0.2rem;
    background-color: rgb(242, 242, 242);
  }
  .advantage {
    padding: 0.8rem 2.55rem;
    h1 {
      font-size: 0.36rem;
      font-weight: 600;
      color: rgba(34, 34, 34, 1);
      margin-bottom: 0.2rem;
    }
    .advantage-title {
      font-weight: 700;
      font-style: normal;
      font-size: 0.24rem;
      color: #333333;
      padding-top: 0.2rem;
    }
    p {
      padding-bottom: 0.1rem;
    }
    .icon {
      visibility: hidden;
    }
    span {
      font-weight: 400;
      font-size: 0.22rem;
    }
    .subheading {
      font-weight: 700;
      color: black;
    }
  }
  .cooperation-case {
    background: rgba(239, 242, 247, 1);
    padding-bottom: 0.7rem;
    h1 {
      font-size: 0.36rem;
      font-weight: 600;
      color: rgba(34, 34, 34, 1);
      text-align: center;
      padding-top: 0.8rem;
      padding-bottom: 0.4rem;
    }
    .cooperation-case-cil {
      display: flex;
      justify-content: center;
      & > div {
        width: 3.6rem;
        height: 2.85rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.04rem;
        opacity: 0.7;
        margin: 0.1rem 0.15rem;
        & > img {
          margin: 0.1rem;
          width: 3.4rem;
          height: 2rem;
        }
        & > div {
          img {
            margin: 0 0.1rem;
            vertical-align: middle;
          }
          span {
            vertical-align: middle;
            font-size: 0.18rem;
            font-weight: 600;
            color: rgba(34, 34, 34, 1);
          }
        }
      }
    }
  }
  .thickening {
    font-weight: 600 !important;
  }
  .service {
    background: rgba(255, 255, 255, 1);
    h1 {
      font-size: 0.36rem;
      font-weight: 600;
      color: rgba(34, 34, 34, 1);
      text-align: center;
      padding-top: 0.8rem;
      padding-bottom: 0.4rem;
    }
    & > div {
      position: relative;
      margin: 0 1.6rem;
      height: 7rem;
      overflow: hidden;
      & > img {
        width: 4.28rem;
        position: absolute;
      }
      & > img:nth-child(1) {
        left: 0;
        z-index: 5;
      }
      & > img:nth-child(2) {
        left: 15%;
        z-index: 4;
      }
      & > img:nth-child(3) {
        left: 30%;
        z-index: 3;
      }
      & > img:nth-child(4) {
        left: 45%;
        z-index: 2;
      }
      & > img:nth-child(5) {
        left: 60%;
        z-index: 1;
      }
      & > img:nth-child(6) {
        left: 75%;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .solution-carousel {
    right: 10% !important;
  }
  .written {
    top: 25% !important;
    right: 4% !important;
    span {
      width: 8.5rem !important;
    }
    img {
      width: 6rem !important;
    }
  }
  .service {
    & > div {
      margin: 0 0.8rem;
    }
  }
}
@media screen and (max-width: 900px) {
  .written {
    left: 45% !important;
  }
  .solution {
    position: relative;
    margin-bottom: 0.5rem;
    & > div {
      position: relative;
      & > img {
        width: 8rem !important;
        margin-left: 0% !important;
      }
      .bnack {
        height: 3.5rem !important;
      }
    }
  }
  .solution-carousel {
    bottom: 35% !important;
  }
  .solution-details {
    padding: 0 0.8rem !important;
  }
  .product-introduction {
    .cooperation-case-cil {
      & > div {
        margin: 0.1rem 0.05rem !important;
        padding-top: 0.05rem;
        img {
          margin: 0 0.1rem 0 !important;
        }
      }
    }
    & > div > div {
      img {
        width: 0.5rem;
      }
    }
    // & > div > div span {
    //   vertical-align: top!important;
    // }
  }
  .advantage {
    img {
      width: 0.15rem;
    }
  }
}
@keyframes gyrate {
  from {
    transform: rotate(0);
  }
  50% {
    transform: rotate(90deg);
  }
  to {
    transform: rotate(180deg);
  }
}
@keyframes revolve {
  from {
    transform: rotate(0);
  }
  50% {
    transform: rotate(-90deg);
  }
  to {
    transform: rotate(-180deg);
  }
}
</style>
